export const ROUTES = {
    SpecialitiesManegement: 'specialities-management',
}